import React, { useState } from 'react';
import { Modal, Form, Button } from 'react-bootstrap';
import { submitPriorityServiceRequest } from '../../api/mechanicalApi';

function PriorityServiceModal({ show, onClose, buildingName, onServiceRequest }) {
  const [phone, setPhone] = useState('');
  const [description, setDescription] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    
    if (isSubmitting) return;
    
    setIsSubmitting(true);
    
    try {
      // Get manager email from localStorage
      let managerEmail = '';
      const userStr = localStorage.getItem('managerUser');
      if (userStr) {
        try {
          const userObj = JSON.parse(userStr);
          managerEmail = userObj.email || '';
        } catch (err) {
          console.error('Error parsing user data:', err);
        }
      }
      
      if (!managerEmail) {
        throw new Error('Manager email not found. Please log in again.');
      }
      
      // Call the API
      await submitPriorityServiceRequest(phone, description, buildingName || 'Building', managerEmail);
      
      // Clear form
      setPhone('');
      setDescription('');
      
      // Show status banner
      if (onServiceRequest) {
        onServiceRequest('Service request submitted - We will contact you within 2 hours');
      }
      
      onClose();
    } catch (error) {
      console.error('Failed to submit priority service request:', error);
      if (onServiceRequest) {
        onServiceRequest(`Failed to submit request: ${error.message}`);
      }
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <Modal show={show} onHide={onClose} centered size="md">
      <Modal.Body style={{ padding: '2rem' }}>
        <div style={{ textAlign: 'center', marginBottom: '1.5rem' }}>
          <img src="https://hudsonhvac.ca/images/logo.png" alt="Hudson Logo" style={{ maxWidth: 100 }} />
        </div>
        <h2 style={{ textAlign: 'center', marginBottom: '0.5rem' }}>Priority Service Request</h2>
        <p style={{ textAlign: 'center', color: '#6b7280', marginBottom: '2rem' }}>
          We will get back to you within 2 hours.<br /><br />
          Or Call Hudson: <strong>(647) 493-4348</strong>
        </p>

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Your Phone Number</Form.Label>
            <Form.Control
              type="tel"
              placeholder="(555) 555-5555"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              required
            />
          </Form.Group>

          <Form.Group className="mb-4">
            <Form.Label>Describe the issue</Form.Label>
            <Form.Control
              as="textarea"
              rows={5}
              placeholder="Briefly describe the issue..."
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
          </Form.Group>

          <Button 
            type="submit" 
            className="btn btn-primary w-100" 
            style={{ backgroundColor: '#2c59a2', borderColor: '#2c59a2' }}
            onMouseEnter={(e) => {
              e.target.style.backgroundColor = '#1e40af';
              e.target.style.borderColor = '#1e40af';
            }}
            onMouseLeave={(e) => {
              e.target.style.backgroundColor = '#2c59a2';
              e.target.style.borderColor = '#2c59a2';
            }}
            disabled={isSubmitting}
          >
            {isSubmitting ? 'Sending...' : 'Request Now'}
          </Button>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default PriorityServiceModal;


